import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TableSkeleton from '../../../components/Skeleton';
import NoResultsFound from '../../../components/NoResultsFound';
import Pagination from '../../../components/Pagination';
import { editInquiryInfo, getInquiriesList } from '../../../redux/features/inquiries/inquiriesService';
import { getAllStaffMembers, getStaffMembers } from '../../../redux/features/staff/staffService';
import { showToast } from '../../../components/ToastMsg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Dropdown from '../../../components/Dropdown/Dropdown';
import BeatLoader from 'react-spinners/BeatLoader';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const Inquiries = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const staffDropdownRef = useRef(null);

    const { isInquiriesLoading, pageCount, inquiries } = useSelector((state) => state.inquiry.inquiriesList);
    const { isLoading, staff } = useSelector((state) => state.staff.staffMembers);
    const { isEditingCustomerRequest } = useSelector((state) => state.customerRequest.editedCustomerRequest);

    const [skip, setSkip] = useState(1);
    const limit = 25;

    const [selectedStaffMember, setSelectedStaffMember] = useState({ id: '', name: '' });
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const fetchAllInquiries = useCallback(
        (filters = {}) => {
            const params = {
                skip: skip,
                limit: limit,
                ...filters,
            };
            dispatch(getInquiriesList(params));
        },
        [dispatch, skip]
    );

    useEffect(() => {
        fetchAllInquiries();
        dispatch(getStaffMembers({}));
    }, [fetchAllInquiries, dispatch]);

    const handleStaffSelect = (option) => {
        setSelectedStaffMember({
            id: option.id,
            name: option.name
        });
    }

    const viewInquiry = (id) => {
        navigate(`/admin/inquiries/${id}`)
    }
    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    const updateDetails = async () => {
        if (selectedStaffMember.name !== '') {
            try {
                const data = {
                    id: selectedRequest.id,
                    agent_id: +selectedStaffMember.id
                }
                const response = await dispatch(editInquiryInfo(data)).unwrap();
                setEditBtnDisable(false);
                setSelectedRequest(null);
                setModalOpen(false);
                showToast('success', response.message);
                fetchAllInquiries();
            }
            catch (error) {
                setEditBtnDisable(false);
                showToast('error', error.message);
            };
        }
    };

    return (
        <div className={`search-card`}>
            <div className={`search-card-header`}>
                <div className={`form-input-col`}>
                    <h1 className={`form-title ${styles.headDiv}`}>
                        Inquiry Listing{' '}
                    </h1>
                </div>
                <div className={`form-input-col`}>
                </div>
            </div>

            <div>
                {isInquiriesLoading ? (
                    <TableSkeleton
                        columns={['Name', 'Email', 'Subject', 'Status', 'Actions']}
                        rowCount={10}
                        height={20}
                    />
                ) : inquiries.length > 0 ? (
                    <div className={`table-container`}>
                        <table className={`table`}>
                            <thead className={`thead`}>
                                <tr>
                                    <th className={`theadColumnOne`}>Name</th>
                                    <th>Email</th>
                                    <th>Message</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className={`tbody`}>
                                {inquiries?.map((inquiry) => (
                                    <tr key={inquiry.id}>
                                        <td className={`tdataColumnOne`}>{inquiry?.name}</td>
                                        <td>{inquiry?.email}</td>
                                        <td>{inquiry?.message}</td>
                                        <td className={styles.smTd}>
                                            <p className={`status-text-label ${inquiry?.status?.toLowerCase()}`}>{inquiry?.status}</p>
                                        </td>
                                        <td className={`actionsBtn`}>
                                            <button className={`btn-view`} onClick={() => {
                                                viewInquiry(inquiry.id);
                                            }}>
                                                View
                                            </button>
                                            <button className={`btn-edit-label`} onClick={() => {
                                                setSelectedRequest(inquiry);
                                                setEditBtnDisable(false);
                                                setErrorMsg(null);
                                                setModalOpen(true);
                                            }}>Assign</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <NoResultsFound />
                )}
                <div className={`search-card-footer`} style={{ marginTop: '20px' }}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isModalOpen &&
                <div className={`modal-overlay`}>
                    <div className={`modal-card`}>
                        <div className={`modal-header`}>
                            <h4 className={`modal-title`}>Update Request</h4>
                            <FontAwesomeIcon icon={faXmark} onClick={() => setModalOpen(false)} size="lg" cursor="pointer" />
                        </div>
                        <div className={`modal-body`}>
                            <div className={styles.formContainer}>
                                <form
                                    className={styles.coordinatorForm}
                                    noValidate
                                >
                                    <div className={`form-input-row md-col`}>
                                        <div className={`form-input-group`}>
                                            <label htmlFor='full_name' className={`form-label`}>
                                                Asign Agent
                                            </label>
                                            <Dropdown
                                                ref={staffDropdownRef}
                                                options={staff.map((member) => ({ id: member.id, name: member.full_name }))}
                                                placeholder="Choose an Option"
                                                onSelect={handleStaffSelect}
                                                value={selectedStaffMember?.name}
                                            />
                                            {errorMsg && (
                                                <p className={`text-danger`}>{errorMsg}</p>
                                            )}
                                        </div>
                                    </div>
                                    <button
                                        className={`btn-primary`}
                                        type='button'
                                        disabled={disabledEditBtn}
                                        onClick={updateDetails}
                                    >
                                        {isEditingCustomerRequest ? <BeatLoader color='#ffffff' /> : `Save`}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default Inquiries;
